import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  InputField,
  Label,
} from "@jem-open/jem-ui";

export interface CreateRegionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  name: string;
  onNameChange: (name: string) => void;
  onConfirm: () => void;
}

/** Create a new Region. Used on the Sites & Regions overview. */
export const CreateRegionDialog: React.FC<CreateRegionDialogProps> = ({
  open,
  onOpenChange,
  name,
  onNameChange,
  onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Create new Region</DialogTitle>
        <DialogDescription>
          Group Sites under a Region for hierarchical reporting and
          configuration.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-xxs mt-md">
        <Label>Region name</Label>
        <InputField
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="e.g. KwaZulu-Natal"
          autoFocus
        />
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button variant="default" disabled={!name.trim()} onClick={onConfirm}>
          Create Region
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default CreateRegionDialog;
